import { render, staticRenderFns } from "./InstallFeedTankModal.vue?vue&type=template&id=2ece174a&"
import script from "./InstallFeedTankModal.vue?vue&type=script&lang=ts&"
export * from "./InstallFeedTankModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports